import React from 'react';
import classNames from 'classnames';
import PrismCode from 'react-prism';
import { hashString } from 'lib/helpers';
import { TableContent } from '../TableContent';
import MathJaxNode from 'lib/editor/DraftEditor/plugins/formulaPlugin/components/MathJaxNode';

const renderGroup = renderChild => (children, { keys, data, depth }) => {
	return children.map((child, idx) => renderChild(child, keys[idx] + idx, data && data[idx], depth))
};

export const createBlockRenderers = () => ({
	'unstyled': renderGroup((child, key) => <p key={key}>{child}</p>),
	'header-one': renderGroup((child, key) => <h1 key={key}>{child}</h1>),
	'header-two': renderGroup((child, key) => <h2 key={key}>{child}</h2>),
	'header-three': renderGroup((child, key) => <h3 key={key}>{child}</h3>),
	'header-four': renderGroup((child, key) => <h4 key={key}>{child}</h4>),
	'header-five': renderGroup((child, key) => <h5 key={key}>{child}</h5>),
	'header-six': renderGroup((child, key) => <h6 key={key}>{child}</h6>),

	'blockquote': (children, { keys }) => (
		<blockquote key={keys.join('|')}>{children.map((x, i) => <p key={i}>{x}</p>)}</blockquote>
	),

	'code-block': renderGroup((child, key, data) => (
		<PrismCode
			component={'pre'}
			key={hashString(String(child)) + key}
			className={classNames('prism-token token', `language-${data && data.syntax || 'js'}`)}>
			{child}
		</PrismCode>
	)),

	'unordered-list-item': (children, { depth, keys }) => (
		<ul key={keys[keys.length - 1]} className={`ul-level-${depth}`}>
			{children.map((child, i) => <li key={i}>{child}</li>)}
		</ul>
	),
	'ordered-list-item': (children, { depth, keys }) => (
		<ol key={keys.join('|')} className={`ol-level-${depth}`}>
			{children.map((child, index) => <li key={keys[index]}>{child}</li>)}
		</ol>
	),

	'atomic': renderGroup((child, key, data) => (
		<figure key={key}>
		{
			data && data.mathjax ? <MathJaxNode>{data.teX}</MathJaxNode> : child
		}
		</figure>
	)),

	'table': renderGroup((child, key, data) => data ? <TableContent key={key} {...data} /> : null)
});



// WEBPACK FOOTER //
// ./lib/viewer/renderers/createBlockRenderers.js